<template>
  <div v-if="dataIsLoad" class="slide-main-block">
    <div v-if="photoCover" class="photo-item" @click="zoomCoverPic(0, $event)">
      <NewImage
        :url="selectedProductCoverImage.Url"
        :size="'_w1000_h1250'"
        :name="itemDatas.Name"
      />
    </div>
    <template v-else>
      <div v-for="(image, index) in selectedProductImg" :key="image.Url" class="photo-item">
        <video
          v-if="image.VideoUrl.length !== 0"
          loop
          autoplay
          muted
          webkit-playsinline
          playsinline
          width="100%"
          class="video-js vjs-default-skin"
        >
          <source
            type="video/mp4"
            :src="
              isMobile
                ? image.VideoMUrl.length !== 0
                  ? image.VideoMUrl
                  : image.VideoUrl
                : image.VideoUrl
            "
          />
        </video>
        <div v-else @click="zoomPic(index, $event)">
          <NewImage :url="image.Url" :size="''" :name="itemDatas.Name" />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';

import useSetEnv from '@global/composable/useSetEnv';
import useZoomBox from '@global/composable/shop/useZoomBox';
import useImage from '@global/composable/useImage';

import NewImage from '@global/components/common/Image/NewImage.vue';

const { setEnv } = useSetEnv();
const { imgTransfer } = useImage();

const props = defineProps({
  photoCover: {
    type: Boolean,
    default: false,
  },
});

const isMobile = setEnv.myEquipment();

const shopContentStore = useShopContentStore();
const { dataIsLoad, selectedData, itemDatas } = storeToRefs(shopContentStore);

const selectedProductCoverImage = computed(() => {
  return selectedData.value.Images.find((img) => img.Category === 11);
});

const selectedProductImg = computed(() => {
  return selectedData.value.Images.filter((img) => img.Category === 0);
});

function zoomCoverPic(index, event) {
  const newDatas = [selectedProductCoverImage.value].map((ele) => {
    return imgTransfer(ele.Url, '');
  });

  useZoomBox({
    images: JSON.parse(JSON.stringify(newDatas)),
    index,
    yPos: event.pageY - window.scrollY,
    tilting: true,
  });
}

function zoomPic(index, event) {
  const newDatas = selectedProductImg.value.map((ele) => {
    if (ele.VideoUrl.length !== 0 || ele.VideoMUrl.length !== 0) {
      // 有影片
      return isMobile.value
        ? imgTransfer(ele.VideoMUrl.length !== 0 ? ele.VideoMUrl : ele.Url, '')
        : imgTransfer(ele.VideoUrl.length !== 0 ? ele.VideoUrl : ele.Url, '');
    }
    return imgTransfer(ele.Url, '');
  });

  useZoomBox({
    images: JSON.parse(JSON.stringify(newDatas)),
    index,
    yPos: event.pageY - window.scrollY,
    tilting: true,
  });
}
</script>
